import styled from '@emotion/styled'

export const AnimationWrapper = styled.div``
